(() => {
  const WIDTH = 1080;
  const HEIGHT = 4000;
  const CORNER_RADIUS = 60;
  const SAFE_MARGIN = 80;

  function initialiseBookmarkDesigner(tool) {
    if (!tool || tool.dataset.initialised === 'true') return;
    tool.dataset.initialised = 'true';

    const fileInput = tool.querySelector('[data-bookmark-file]');
    const canvas = tool.querySelector('[data-bookmark-canvas]');
    const zoomInput = tool.querySelector('[data-bookmark-zoom]');
    const rotationInput = tool.querySelector('[data-bookmark-rotation]');
    const backgroundInput = tool.querySelector('[data-bookmark-background]');
    const safeAreaInput = tool.querySelector('[data-show-safe-area]');
    const holeInput = tool.querySelector('[data-show-hole]');
    const zoomOutput = tool.querySelector('[data-zoom-output]');
    const rotationOutput = tool.querySelector('[data-rotation-output]');
    const downloadButton = tool.querySelector('[data-download-bookmark]');
    const resetButton = tool.querySelector('[data-reset-bookmark]');
    const centreButton = tool.querySelector('[data-centre-image]');
    const status = tool.querySelector('[data-bookmark-status]');

    if (
      !fileInput ||
      !canvas ||
      !zoomInput ||
      !rotationInput ||
      !backgroundInput
    ) {
      return;
    }

    const context = canvas.getContext('2d');

    canvas.width = WIDTH;
    canvas.height = HEIGHT;

    let uploadedImage = null;
    let offsetX = 0;
    let offsetY = 0;
    let dragging = false;
    let lastPointerX = 0;
    let lastPointerY = 0;

    function roundedRectanglePath(ctx, x, y, width, height, radius) {
  const safeRadius = Math.min(radius, width / 2, height / 2);

  ctx.beginPath();
  ctx.moveTo(x + safeRadius, y);
  ctx.lineTo(x + width - safeRadius, y);
  ctx.quadraticCurveTo(x + width, y, x + width, y + safeRadius);
  ctx.lineTo(x + width, y + height - safeRadius);
  ctx.quadraticCurveTo(
    x + width,
    y + height,
    x + width - safeRadius,
    y + height
  );
  ctx.lineTo(x + safeRadius, y + height);
  ctx.quadraticCurveTo(x, y + height, x, y + height - safeRadius);
  ctx.lineTo(x, y + safeRadius);
  ctx.quadraticCurveTo(x, y, x + safeRadius, y);
  ctx.closePath();
}

    function drawArtwork(ctx) {
      ctx.clearRect(0, 0, WIDTH, HEIGHT);

      ctx.save();
      roundedRectanglePath(ctx, 0, 0, WIDTH, HEIGHT, CORNER_RADIUS);
      ctx.clip();

      ctx.fillStyle = backgroundInput.value || '#ffffff';
      ctx.fillRect(0, 0, WIDTH, HEIGHT);

      if (uploadedImage) {
        const coverScale = Math.max(
          WIDTH / uploadedImage.naturalWidth,
          HEIGHT / uploadedImage.naturalHeight
        );

        const zoomScale = Number(zoomInput.value) / 100;
        const scale = coverScale * zoomScale;

        const imageWidth = uploadedImage.naturalWidth * scale;
        const imageHeight = uploadedImage.naturalHeight * scale;
        const rotation = Number(rotationInput.value) * Math.PI / 180;

        ctx.translate(
          WIDTH / 2 + offsetX,
          HEIGHT / 2 + offsetY
        );
        ctx.rotate(rotation);

        ctx.drawImage(
          uploadedImage,
          -imageWidth / 2,
          -imageHeight / 2,
          imageWidth,
          imageHeight
        );
      }

      ctx.restore();
    }

    function drawGuides(ctx) {
      ctx.save();

      if (safeAreaInput?.checked) {
        ctx.setLineDash([28, 18]);
        ctx.lineWidth = 8;
        ctx.strokeStyle = 'rgba(103, 75, 137, 0.9)';

        roundedRectanglePath(
          ctx,
          SAFE_MARGIN,
          SAFE_MARGIN,
          WIDTH - SAFE_MARGIN * 2,
          HEIGHT - SAFE_MARGIN * 2,
          42
        );

        ctx.stroke();
      }

      if (holeInput?.checked) {
        const holeSize = 80;
        const holeCentreX = WIDTH / 2;
        const holeCentreY = 60;

        ctx.setLineDash([14, 10]);
        ctx.lineWidth = 8;
        ctx.strokeStyle = 'rgba(219, 68, 104, 0.95)';
        ctx.fillStyle = 'rgba(255, 255, 255, 0.7)';

        ctx.beginPath();
        ctx.arc(
          holeCentreX,
          holeCentreY,
          holeSize / 2,
          0,
          Math.PI * 2
        );
        ctx.fill();
        ctx.stroke();

        ctx.setLineDash([]);
        ctx.fillStyle = '#8c2945';
        ctx.font = '700 36px sans-serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'top';
        ctx.fillText('Tassel hole', holeCentreX, holeCentreY + 55);
      }

      ctx.restore();
    }

    function drawPlaceholder(ctx) {
      if (uploadedImage) return;

      ctx.save();
      ctx.fillStyle = '#665f69';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.font = '700 52px sans-serif';
      ctx.fillText('Your artwork will appear here', WIDTH / 2, HEIGHT / 2);

      ctx.font = '38px sans-serif';
      ctx.fillText(
        'Choose an image to begin',
        WIDTH / 2,
        HEIGHT / 2 + 75
      );
      ctx.restore();
    }

    function renderPreview() {
      drawArtwork(context);
      drawPlaceholder(context);
      drawGuides(context);
    }

    function resetPosition() {
      offsetX = 0;
      offsetY = 0;
      zoomInput.value = '100';
      rotationInput.value = '0';
      zoomOutput.textContent = '100%';
      rotationOutput.textContent = '0°';
    }

    fileInput.addEventListener('change', (event) => {
      const file = event.target.files?.[0];

      if (!file) return;

      if (!file.type.startsWith('image/')) {
        status.textContent = 'Please choose a PNG, JPG or WEBP image.';
        return;
      }

      const reader = new FileReader();

      reader.onload = () => {
        const image = new Image();

        image.onload = () => {
          uploadedImage = image;
          resetPosition();
          status.textContent =
            'Image added. Drag it or use the controls to adjust the layout.';
          renderPreview();
        };

        image.onerror = () => {
          status.textContent =
            'That image could not be opened. Please try another file.';
        };

        image.src = reader.result;
      };

      reader.onerror = () => {
        status.textContent =
          'The image could not be read. Please try another file.';
      };

      reader.readAsDataURL(file);
    });

    zoomInput.addEventListener('input', () => {
      zoomOutput.textContent = `${zoomInput.value}%`;
      renderPreview();
    });

    rotationInput.addEventListener('input', () => {
      rotationOutput.textContent = `${rotationInput.value}°`;
      renderPreview();
    });

    backgroundInput.addEventListener('input', renderPreview);
    safeAreaInput?.addEventListener('change', renderPreview);
    holeInput?.addEventListener('change', renderPreview);

    tool.querySelectorAll('[data-nudge-x]').forEach((button) => {
      button.addEventListener('click', () => {
        offsetX += Number(button.dataset.nudgeX) * 4;
        renderPreview();
      });
    });

    tool.querySelectorAll('[data-nudge-y]').forEach((button) => {
      button.addEventListener('click', () => {
        offsetY += Number(button.dataset.nudgeY) * 4;
        renderPreview();
      });
    });

    centreButton?.addEventListener('click', () => {
      offsetX = 0;
      offsetY = 0;
      renderPreview();
      status.textContent = 'Image centred.';
    });

    canvas.addEventListener('pointerdown', (event) => {
      if (!uploadedImage) return;

      dragging = true;
      lastPointerX = event.clientX;
      lastPointerY = event.clientY;
      canvas.setPointerCapture(event.pointerId);
    });

    canvas.addEventListener('pointermove', (event) => {
      if (!dragging || !uploadedImage) return;

      const rectangle = canvas.getBoundingClientRect();
      const scaleX = WIDTH / rectangle.width;
      const scaleY = HEIGHT / rectangle.height;

      offsetX += (event.clientX - lastPointerX) * scaleX;
      offsetY += (event.clientY - lastPointerY) * scaleY;

      lastPointerX = event.clientX;
      lastPointerY = event.clientY;

      renderPreview();
    });

    function stopDragging(event) {
      if (!dragging) return;

      dragging = false;

      if (canvas.hasPointerCapture(event.pointerId)) {
        canvas.releasePointerCapture(event.pointerId);
      }
    }

    canvas.addEventListener('pointerup', stopDragging);
    canvas.addEventListener('pointercancel', stopDragging);

    downloadButton.addEventListener('click', () => {
      if (!uploadedImage) {
        status.textContent =
          'Please choose an image before downloading your bookmark.';
        return;
      }

      const exportCanvas = document.createElement('canvas');
      exportCanvas.width = WIDTH;
      exportCanvas.height = HEIGHT;

      const exportContext = exportCanvas.getContext('2d');

      if (!exportContext) {
        status.textContent = 'The PNG could not be created.';
        return;
      }

      drawArtwork(exportContext);

      exportCanvas.toBlob((blob) => {
        if (!blob) {
          status.textContent = 'The PNG could not be created.';
          return;
        }

        const objectUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = objectUrl;
        link.download = 'bookmark-design-54x200mm.png';
        document.body.appendChild(link);
        link.click();
        link.remove();

        window.setTimeout(() => {
          URL.revokeObjectURL(objectUrl);
        }, 1000);

        status.textContent =
          'Your 1080 x 4000 px bookmark PNG has been downloaded.';
      }, 'image/png');
    });

    resetButton.addEventListener('click', () => {
      uploadedImage = null;
      fileInput.value = '';
      offsetX = 0;
      offsetY = 0;
      zoomInput.value = '100';
      rotationInput.value = '0';
      backgroundInput.value = '#ffffff';

      if (safeAreaInput) safeAreaInput.checked = true;
      if (holeInput) holeInput.checked = true;

      zoomOutput.textContent = '100%';
      rotationOutput.textContent = '0°';
      status.textContent = 'Choose an image to begin.';

      renderPreview();
    });

    renderPreview();
  }

  function initialiseAllBookmarkDesigners(container = document) {
    container
      .querySelectorAll('[data-bookmark-designer]')
      .forEach(initialiseBookmarkDesigner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initialiseAllBookmarkDesigners();
    });
  } else {
    initialiseAllBookmarkDesigners();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialiseAllBookmarkDesigners(event.target);
  });
})();